import { Link, Outlet } from "react-router-dom";
import { AiOutlineUser } from "react-icons/ai";
import { RiFileEditFill } from "react-icons/ri";
import { useAuth } from "../../context/AuthContext";

const SimpleSidebar = () => {
  const { loggedInUser } = useAuth();

  return (
    <div className="flex flex-row flex-1 min-h-0">
      <div className="h-full p-5 w-60 flex flex-col space-y-4">
        <div className="flex-1"></div>
        <div className="flex flex-row items-center w-full px-8 py-2 space-x-4 rounded-md hover:bg-gray-200">
          <AiOutlineUser className="text-4xl" />
          <p className="break-all text-sm">{loggedInUser?.email}</p>
        </div>
        <Link
          to="/logout"
          className="flex flex-row items-center w-full px-8 py-2 space-x-4 text-xl rounded-md hover:bg-gray-200 cursor-pointer"
        >
          <RiFileEditFill />
          <p>Logout</p>
        </Link>
      </div>
      <div className="h-full flex-1 p-2">
        <div className="h-full rounded-3xl shadow-2xl">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SimpleSidebar;
